import axios, { type AxiosResponse } from 'axios'

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? ''

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  validateStatus: () => true,
  withCredentials: true,
})

export function assertOk(response: AxiosResponse<unknown>, fallback: string) {
  if (response.status < 200 || response.status >= 300) {
    throw new Error(fallback)
  }
}

export function csrfHeaders(csrfToken: string) {
  return {
    'X-CSRFToken': csrfToken,
  }
}

export function jsonHeaders(csrfToken: string) {
  return {
    ...csrfHeaders(csrfToken),
    'Content-Type': 'application/json',
  }
}

export function formHeaders(csrfToken: string) {
  return {
    ...csrfHeaders(csrfToken),
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  }
}

export function legacyFormBody(payload: Record<string, unknown> = {}) {
  return new URLSearchParams({
    data: JSON.stringify(payload),
  })
}

export function responseText(response: AxiosResponse<unknown>) {
  return typeof response.data === 'string' ? response.data : ''
}

export function errorMessage(errors: unknown, fallback: string) {
  if (!errors) {
    return fallback
  }

  if (typeof errors === 'string') {
    return errors
  }

  try {
    return JSON.stringify(errors)
  } catch {
    return fallback
  }
}
